module.exports = __webpack_public_path__ + "img/pet-friendly-img.1c67b746.jpg";